import React from 'react';
import style from './style.scss';
import {MyBusinessAnnouncementDetailContent} from './sub-view/announcement';
import {BusinessLayout} from 'components/layouts/business';

class MyBusinessAnnouncementDetailContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <BusinessLayout active='my-business-announcements'>
        <h1 className="user-header">Thông báo</h1>
        <MyBusinessAnnouncementDetailContent params={this.props.params}/>
      </BusinessLayout>
    );
  }
}

export default MyBusinessAnnouncementDetailContainer;



// WEBPACK FOOTER //
// ./components/my-business/MyBusinessAnnouncementDetailContainer.jsx